import { t } from 'i18next';

export const contactsExportFields = () => {
    return [
        {
            label: t('First Name'),
            value: 'first_name',
        },
        {
            label: t('Last Name'),
            value: 'last_name',
        },
        {
            label: t('Email'),
            value: row =>
                row.email_addresses.map(email => email.email).join('; '),
        },
        {
            label: t('Phone'),
            value: row =>
                row.phone_numbers.map(phone => phone.phone_number).join('; '),
        },
        {
            label: t('Street'),
            value: 'street',
        },
        {
            label: t('House Number'),
            value: 'house_number',
        },
        {
            label: t('Apartment Number'),
            value: 'apartment_number',
        },
        {
            label: t('City'),
            value: 'city',
        },
        {
            label: t('Country'),
            value: row => row.country?.toCountryDisplayName(),
        },
        {
            label: t('State'),
            value: 'state',
        },
        {
            label: t('Zip Code'),
            value: 'zip_code',
        },
    ];
};
